/** Chips y copy por pantalla (D7 fase 4 — sin embeddings). */
export const ASSISTANT_SCREEN_CONTEXTS = {
  onboarding: {
    id: 'onboarding',
    label: 'Primeros pasos',
    intro: 'Dudas mientras cargás tu primer cliente y venta.',
    suggestions: [
      '¿Por dónde empiezo?',
      '¿Dejo la venta impaga?',
      '¿Dónde veo quién me debe?',
      '¿Contsuite factura a ARCA?',
    ],
  },
  cobranzas: {
    id: 'cobranzas',
    label: 'Cobrar',
    intro: 'Prioridad, gestiones y conciliación.',
    suggestions: [
      '¿A quién cobro primero?',
      '¿Cómo registro una promesa?',
      '¿Qué es el impacto de cobranza?',
      '¿Concilio pagos de Mercado Pago?',
    ],
  },
  'cuenta-cobro': {
    id: 'cuenta-cobro',
    label: 'Medios de cobro',
    intro: 'Alias, CBU y mensajes de WhatsApp.',
    suggestions: [
      '¿Qué pongo en alias y CBU?',
      '¿Validan el titular del CBU?',
      '¿Dónde va el link de pago?',
      '¿Qué sale en el WhatsApp al cliente?',
    ],
  },
  'inicio-semana': {
    id: 'inicio-semana',
    label: 'Tu semana',
    intro: 'Preguntá por prioridades y cierre.',
    suggestions: [
      '¿A quién cobro primero?',
      '¿Cómo está el DSO?',
      '¿Qué falta para el cierre?',
      '¿Factura a ARCA?',
    ],
  },
};

export function getAssistantContext(contextId) {
  return ASSISTANT_SCREEN_CONTEXTS[contextId] || ASSISTANT_SCREEN_CONTEXTS['inicio-semana'];
}
